module.exports = __webpack_public_path__ + "img/RegFees-7-ondemand.7e987ec9.svg";